import { ScrollView, useWindowDimensions } from "react-native";
import { GestureViewer } from "react-native-gesture-image-viewer";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { ModalTestID } from "@/constants/TestID";
import SafeNativeModal from "@/ui/composed/modal/SafeNativeModal";
import { FAIconName, IconButton, Image } from "@/ui/core";
import { Box } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface ImageViewerModalProps {
  contentType?: string;
  imageUrl: string;
  isVisible: boolean;
  onClose: () => void;
  testID: string;
}

enum ImageViewerModalConfig {
  DismissButtonAccessibilityLabel = "Close image viewer",
}

const ImageViewerModal = ({
  contentType,
  imageUrl,
  isVisible,
  onClose,
  testID,
}: ImageViewerModalProps) => {
  const { height: windowHeight, width: windowWidth } = useWindowDimensions();
  const { top } = useSafeAreaInsets();

  const baseTestID = joinTestIDs(testID, ModalTestID.ImageViewer);

  const renderImage = (uri: string) => (
    <Image
      contentFit="contain"
      contentType={contentType}
      size={{ height: windowHeight, width: windowWidth }}
      testID={baseTestID}
      uriSource={uri}
    />
  );

  return (
    <SafeNativeModal
      animationType="fade"
      onRequestClose={onClose}
      transparent
      visible={isVisible}
    >
      <GestureViewer
        data={[imageUrl]}
        ListComponent={ScrollView}
        onDismiss={onClose}
        renderItem={renderImage}
      />
      <Box position="absolute" right={12} top={top + 12}>
        <IconButton
          accessibilityLabel={
            ImageViewerModalConfig.DismissButtonAccessibilityLabel
          }
          iconName={FAIconName.Times}
          onPress={onClose}
          testID={joinTestIDs(baseTestID, "close")}
          variant="primarySolid"
        />
      </Box>
    </SafeNativeModal>
  );
};

export default ImageViewerModal;
export { ImageViewerModalConfig };
export type { ImageViewerModalProps };
